<div #shellPortal>
  @if (isOpen()) {
  <!-- Backdrop -->
  <button
    type="button"
    class="fixed inset-0 bg-black/25 dark:bg-black/45 backdrop-blur-sm cursor-default"
    style="z-index: 1000"
    aria-label="Close"
    (click)="onClose()"
  ></button>

  <!-- Modal: bottom sheet (mobile) / centered dialog (desktop) — UN SOLO ng-content -->
  <div
    class="fixed bottom-0 left-0 right-0 md:inset-0 md:flex md:items-center md:justify-center md:p-4"
    style="z-index: 1001"
  >
    <div
      class="bg-white/80 dark:bg-[rgba(15,23,42,0.92)] backdrop-blur-[40px] dark:backdrop-blur-[48px] border-t border-white/30 dark:border-white/10 md:border shadow-[0_-8px_40px_rgba(0,0,0,0.06)] dark:shadow-[0_-8px_40px_rgba(0,0,0,0.5)] md:shadow-[0_16px_48px_rgba(0,0,0,0.1)] md:dark:shadow-[0_16px_48px_rgba(0,0,0,0.5)] rounded-t-[28px] md:rounded-3xl max-h-[90vh] overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:min-w-[480px] md:max-w-lg"
    >
      @if (showHandle()) {
      <!-- Handle pill: only on mobile -->
      <div class="flex justify-center pt-5 mb-3 md:hidden">
        <div class="w-10 h-1 rounded-full bg-black/15 dark:bg-white/20"></div>
      </div>
      } @if (title()) {
      <div
        class="flex items-center justify-between px-6 md:px-7 pb-5 md:pt-7"
        [class.pt-3]="showHandle()"
        [class.pt-6]="!showHandle()"
      >
        <h3
          class="text-lg md:text-xl font-bold text-slate-800 dark:text-white font-serif"
        >
          {{ title() }}
        </h3>
        <button
          type="button"
          class="w-8 h-8 md:w-9 md:h-9 rounded-lg md:rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-white md:hover:bg-slate-100 md:dark:hover:bg-white/10 transition-colors cursor-pointer"
          (click)="onClose()"
        >
          <span class="material-symbols-outlined !text-[20px] md:!text-[22px]"
            >close</span
          >
        </button>
      </div>
      }
      <!-- Contenido: único ng-content -->
      <div
        class="px-6 md:px-7 pb-[calc(env(safe-area-inset-bottom,0px)+2rem)] md:pb-7"
      >
        <ng-content />
      </div>
    </div>
  </div>
  }
</div>
